<template>
  <el-button type="primary"
             icon="el-icon-refresh"
             circle
             @click="refreshView" />
</template>

<script>
export default {
  name: 'RefreshButton',
  methods: {
    refreshView () {
      // In order to make the cached page re-rendered
      // this.$store.dispatch('tagsView/delAllCachedViews', this.$route)

      const { fullPath } = this.$route

      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + fullPath
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RefreshButton.vue